class SaveEtoUseCase {
  constructor(repository) {
    this.repository = repository;
  }
  async execute({ FK_STATION, DATA, START,END}) {
    let station_et0 = await this.repository.showEtoByStationAndInterval({
      FK_STATION,
      START,
      END,
    });


    let formatted_et0=DATA.map(item=>{
      let [TIME,VALUE]=item
      return {FK_STATION,TIME,VALUE}
    })



    if(station_et0.length){
        for (let et0 of formatted_et0) {
            let alreadyExists = station_et0.some((item) => item.TIME == et0.TIME);
            if (alreadyExists) {
                continue;
            }
            station_et0.push(et0);
        }

    }else{
        station_et0=formatted_et0
    }

    let row_values=``

    station_et0.forEach((row,index,rows)=>{
      let {
        FK_STATION,
        TIME,
        VALUE
      }=row

      row_values+= `(${FK_STATION},'${TIME}','${VALUE}')${index === rows.length - 1 ? "" : ","}`;
    })

    //Deletar por intervalo e não tudo, pois pode apagar o que o CRON já tenha feito beeemmm
    //atrás
    if (station_et0.length) {
      await this.repository.deleteByInterval(FK_STATION,START,END)
    }

    return await this.repository.savePrevData(row_values);

  }
}
export {
  SaveEtoUseCase,
};
